import { Merchant } from '@slerp/controls'

export const crmUrl = (merchantSetting: Merchant) => {
  if (merchantSetting?.integration_settings?.crm?.enabled) {
    return 'https://app.crm.slerp.com/#/login'
  } else {
    return 'https://www.slerp.com/crm-book-a-demo/'
  }
}

export const shouldHideLayoutElements = (pathname: string): boolean => {
  const transparentBackgroundPaths = [
    '/availability-rules/',
    '/discounts/create',
    '/discounts/basket/',
    '/discount/basket/create',
    '/discounts/product/create',
    '/discounts/product',
    '/discounts/delivery-charge/create',
    '/discounts/delivery-charge',
    '/integrations/*'
  ]

  const creationFlowEndings = ['/create', '/new']

  const hasTransparentBackgroundPath = transparentBackgroundPaths.some(
    (path) => {
      if (path.includes('*')) {
        const escapedPath = path.replace(/[.+?^${}()|[\]\\]/g, '\\$&')
        const pattern = escapedPath.replace(/\*/g, '.*')
        const regex = new RegExp(`^${pattern}`)
        return regex.test(pathname)
      }
      return pathname.includes(path)
    }
  )

  // Check for UUID pattern in product discount paths (edit flows)
  const isProductDiscountEdit = /\/discounts\/product\/[a-f0-9-]{36}$/i.test(
    pathname
  )

  const isDrawerBasedCreation = pathname.match(
    /^\/(products|modifiers|loyalty\/cards|loyalty\/bonuses|app-campaigns)(?:\/[^\/]+)?\/(new|create)$/
  )

  const isCreationFlow =
    pathname.split('/rule/')[1]?.length > 0 ||
    (creationFlowEndings.some((ending) => pathname.endsWith(ending)) &&
      !isDrawerBasedCreation) ||
    isProductDiscountEdit

  return hasTransparentBackgroundPath || isCreationFlow
}
